import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const PersonIcon = (props) => (
  <SvgIcon {...props}>
    <path
      d="M12 3C10.9391 3 9.92172 3.42143 9.17157 4.17157C8.42143 4.92172 8 5.93913 8 7C8 8.06087 8.42143 9.07828 9.17157 9.82843C9.92172 10.5786 10.9391 11 12 11C13.0609 11 14.0783 10.5786 14.8284 9.82843C15.5786 9.07828 16 8.06087 16 7C16 5.93913 15.5786 4.92172 14.8284 4.17157C14.0783 3.42143 13.0609 3 12 3ZM8.47266 14.502C8.38922 14.5015 8.30491 14.512 8.22266 14.5332C5.59266 15.2092 3 16.532 3 18.5V20C3 20.552 3.448 21 4 21H20C20.552 21 21 20.552 21 20V18.5C21 16.532 18.4064 15.2092 15.7754 14.5332C15.4464 14.4482 15.0905 14.5392 14.8535 14.7832C14.1295 15.5302 13.123 16 12 16C10.877 16 9.87148 15.5302 9.14648 14.7832C8.96873 14.6002 8.72297 14.5034 8.47266 14.502Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

PersonIcon.propTypes = {
  sx: PropTypes.object,
};

export default PersonIcon;
